var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cargoproject"},[_c('Header',{attrs:{"pages":_vm.pages,"contacts":_vm.contacts}}),_c('Main',{attrs:{"pages":_vm.pages,"contacts":_vm.contacts,"cards":_vm.cards}}),_c('Footer',{attrs:{"contacts":_vm.contacts,"footerLinks":_vm.footerLinks}}),_c('Copyright')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }